import { useContext, useEffect, useState } from 'react';
import StepButton from '../../../../../../../components/stepButton/stepButton';
import { DiefCfemContext } from '../../../../../../../contexts/DiefCfemContext';
import {
  ETabTitularArrendatario,
  IEstadoTitularArrendatario,
} from '../../../../../lib/titularArrendatarioEstadoProcesso';
import ListagemOperacoes from './components/listagemOperacoes/listagemOperacoes';
import SituacaoProcesso from './components/situacaoProcesso/situacaoProcesso';
import styles from './outrosRegimesTab.module.scss';

interface IProps {
  setIsEdicaoOutrosRegimes: React.Dispatch<React.SetStateAction<boolean>>;
  estadoTela: IEstadoTitularArrendatario | null;
  setEstadoTela: React.Dispatch<React.SetStateAction<IEstadoTitularArrendatario | null>>;
}

export const OutrosRegimesTab = ({ setIsEdicaoOutrosRegimes, estadoTela, setEstadoTela }: IProps) => {
  const STEP_CONFIGURACAO = 1;
  const STEP_LISTAGEM_OPERACOES = 2;

  const context = useContext(DiefCfemContext);
  const declaracaoId = context?.declaracaoTitularArrendatario.id || '';

  const [currentStep, setCurrentStep] = useState(1);
  const [triggerSalvarConfiguracao, setTriggerSalvarConfiguracao] = useState(false);

  useEffect(() => {
    if (estadoTela) {
      if (estadoTela.telaSelecionada === ETabTitularArrendatario.OUTROS_REGIMES_CONFIGURACAO) {
        setCurrentStep(STEP_CONFIGURACAO);
      } else if (estadoTela.telaSelecionada === ETabTitularArrendatario.OUTROS_REGIMES_LISTAGEM) {
        setCurrentStep(STEP_LISTAGEM_OPERACOES);
      }
    }
  }, [estadoTela]);

  const atualizarEstadoTela = () => {
    const novoEstado = {
      telaSelecionada: ETabTitularArrendatario.OUTROS_REGIMES_CONFIGURACAO,
    };

    setEstadoTela(novoEstado);
  };

  const onChangeStepButton = (newStep: number) => {
    /*
      Tela de listagem operações só será exibida de acordo com o
      resultado dos eventos realizados em situacaoProcesso
    */
    if (newStep === STEP_LISTAGEM_OPERACOES) {
      setTriggerSalvarConfiguracao(true);
    } else {
      atualizarEstadoTela();

      setCurrentStep(newStep);
      setTriggerSalvarConfiguracao(false);
    }
  };

  return (
    <>
      <div className={styles.aba} data-testid='outros-regimes-tab'>
        <div className={styles.stepContainer}>
          <StepButton
            steps={['Situação Operacional do Processo', 'Listagem de Operações']}
            selectedStep={currentStep}
            onChange={(value) => onChangeStepButton(value)}
          />
        </div>
        <div>
          {currentStep === 1 && (
            <SituacaoProcesso
              triggerSalvarConfiguracao={triggerSalvarConfiguracao}
              declaracaoId={declaracaoId}
              changeStep={() => setCurrentStep(STEP_LISTAGEM_OPERACOES)}
              setIsEdicaoOutrosRegimes={setIsEdicaoOutrosRegimes}
              estadoTela={estadoTela}
              setEstadoTela={setEstadoTela}
            />
          )}
          {currentStep === 2 && (
            <ListagemOperacoes
              declaracaoId={declaracaoId}
              setIsEdicaoOutrosRegimes={setIsEdicaoOutrosRegimes}
              estadoTela={estadoTela}
              setEstadoTela={setEstadoTela}
            />
          )}
        </div>
      </div>
    </>
  );
};
